module.exports = __webpack_public_path__ + "static/img/zd_indicator.png";